import { Typography } from '@mui/material';

interface RecordingTimerProps {
  recordingTime: number;
  textBefore?: string
}

/**
 * Компонент для отображения времени записи в формате MM:SS:00
 */
const RecordingTimer = ({ recordingTime, textBefore }: RecordingTimerProps) => {
  // Функция для форматирования времени в формат MM:SS:00
  const formatTime = (seconds: number): string => {
    return new Date(seconds * 1000).toISOString().slice(14, 19);
  };

  return (
    <Typography textAlign="center" variant="subtitle2" sx={{ fontFamily: 'monospace' }}>
      {textBefore}{' '}
      {formatTime(recordingTime)}
    </Typography>
  );
};

export default RecordingTimer;
